import EventSummary from '@/components/event-summary/event-summary.view';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { Box, Heading } from '@chakra-ui/react';
import { DateTime } from 'luxon';

interface IProps {
	dateTime: DateTime;
	events: Array<ICalendarEvent>;
	heading: string;
	onEventClick: (event: ICalendarEvent) => void;
}

export default function Day(props: IProps) {
	return (
		<Box
			h="full"
			overflow="auto"
			minW={'xs'}
			borderRightWidth={1}
			borderRightColor="gray.100"
			_first={{
				borderLeftWidth: 1,
				borderLeftColor: 'gray.100',
			}}
		>
			<Heading size="sm" borderBottomWidth={1} borderBottomColor="gray.100" p={2}>
				{props.heading}
			</Heading>

			<Box display="grid" gap={2} onClick={() => props.onEventClick(props.events[0])} p={2}>
				{props.events.map((e) => {
					return <EventSummary key={e.id} event={e} />;
				})}
			</Box>
		</Box>
	);
}
